import Column from '@sdk/components/ui/spacing/Column';

import RosterEmptyStateSvg from '@web/assets/svg/Misc/empty-roster-state.svg';
import TextSecondLine from '@web/roster/EmptyStates/components/TextSecondLine';
import TextFirstLine from '@web/roster/EmptyStates/components/TextFirstLine';

const SVG_DISPLACEMENT = 64;

type Props = {
  date: string;
  showResetFilters: boolean;
  hasShiftsWithinTwoWeeks: boolean;
  clearFilters: () => void;
};
const RosterEmptyStates = ({
  date,
  showResetFilters,
  hasShiftsWithinTwoWeeks,
  clearFilters,
}: Props) => {
  return (
    <Column mTop={40} mBottom={40} alignItems="center">
      <Column mTop={20} mLeft={SVG_DISPLACEMENT} mBottom={20}>
        <RosterEmptyStateSvg />
      </Column>
      <TextFirstLine date={date} />
      <Column>
        <TextSecondLine
          date={date}
          hasShiftsWithinTwoWeeks={hasShiftsWithinTwoWeeks}
          showResetFilters={showResetFilters}
          clearFilters={clearFilters}
        />
      </Column>
    </Column>
  );
};

export default RosterEmptyStates;
